import { Component, Input } from '@angular/core';
import { AttachedFile } from '../../../../../alden-extension/src/lib/models/attached-file';
import { FormGroup } from '@angular/forms';
import { UdeuFile } from 'projects/deusto-extension/src/lib/model/classes/udeu-files';
import { WatermarkParams } from 'projects/alden-extension/src/lib/models/watermark-params';

@Component({
  selector: 'alden-attach-files',
  templateUrl: './attach-files.component.html',
  styleUrls: ['./attach-files.component.scss']
})
export class AttachFilesComponent {
  @Input() label: string;
  @Input() group: FormGroup<any>;
  @Input() controlName: string;
  @Input() udeuFiles: UdeuFile[];
  @Input() editableFields: string[];
  @Input() mandatoryFields: string[];
  @Input() maxFiles: number;
  @Input() smallSize: boolean;
  @Input() mimeTypes: string[];
  @Input() downloadEnabled: boolean = false;
  @Input() watermarkParams: WatermarkParams | undefined;
  @Input() allowedDownloadGroups: string[] | undefined;

  files: AttachedFile[];

  constructor() {
    this.files = [];
  }

  ngOnInit(): void {
    if (this.udeuFiles) {
      this.files = this.udeuFiles.filter((udeuFile) => udeuFile).map((udeuFile) => {
        const attachedFile = new AttachedFile(udeuFile.name);
        attachedFile.uuid = udeuFile.uuid;
        attachedFile.title = udeuFile.title;
        attachedFile.description = udeuFile.description;
        attachedFile.mimeType = udeuFile.mimetype;
        attachedFile.size = udeuFile.size;
        attachedFile.lastModDate = udeuFile.modified;
        return attachedFile;
      });
      this.group.get(this.controlName).setValue(this.files);
    }
    if(!this.editableFields) 
      this.editableFields = ['name', 'description'];
  }
}
